import { Location } from "react-router";
import { StateCreator } from "zustand";

export interface NavigationSlice {
  navigation: {
    redirect: {
      location: Location<unknown> | null;
      triggered: boolean;
    };

    setRedirect: (props: Partial<NavigationSlice["navigation"]["redirect"]>) => void;
  };
}

const createNavigationSlice: StateCreator<NavigationSlice, [], [], NavigationSlice> = (set) => ({
  navigation: {
    redirect: {
      location: null,
      triggered: false,
    },
    setRedirect: (props) =>
      set((state) => ({
        navigation: {
          ...state.navigation,
          redirect: { ...state.navigation.redirect, ...props },
        },
      })),
  },
});

export default createNavigationSlice;
